/**
 * WHICH COMBATANTS ARE AN AREA RATHER THAN A BODY.
 *
 * A horde is a hundred orks spread over twenty metres, so a template that
 * clips its flank catches it - `hordeRadius` turns magnitude into that disc.
 * Everyone else is one person standing on one spot.
 *
 * THIS EXISTS BECAUSE MAGNITUDE ALONE IS NOT THE QUESTION. Every character
 * carries `horde: { isHorde: false, magnitude: 30 }` from `emptyCharacter`,
 * so a rule of "magnitude > 0" makes EVERY combatant a 2.2 m mob. Blast
 * radii grew by that much, and cones - where the bulk becomes an angular
 * spread of `asin(bulk / distance)` - grew by about 26° at five metres. The
 * shape drawn on the map was right and the shape that hurt people was not
 * (v8.152.0).
 *
 * `projectDefender` is the authority for `isHorde`, the same one the map's
 * own horde discs consult. One computation, three consumers: the preview, the
 * attack, and the overlay. Computing it a fourth way is how they came to
 * disagree in the first place.
 */
import { projectDefender } from './projection';
import type { Combatant } from './types';

/** Magnitude per combatant id, for the combatants that really are hordes. */
export function hordeMagnitudes(roster: readonly Combatant[]): Record<string, number> {
  const out: Record<string, number> = {};
  for (const c of roster) {
    const horde = projectDefender(c)?.horde;
    if (horde?.isHorde && horde.magnitude > 0) out[c.id] = horde.magnitude;
  }
  return out;
}
